(function () {
  function init(el) {
    const date = el.dataset.countdownDate;
    const time = el.dataset.countdownTime || '00:00';
    const hideEnded = el.dataset.hideEnded === 'true';

    if (!date) return;

    const end = new Date(`${date}T${time}:00`).getTime();

    const d = el.querySelector('[data-days]');
    const h = el.querySelector('[data-hours]');
    const m = el.querySelector('[data-minutes]');
    const s = el.querySelector('[data-seconds]');

    function tick() {
      const diff = end - Date.now();

      if (diff <= 0) {
        if (hideEnded) el.style.display = 'none';
        clearInterval(timer);
        return;
      }

      d.textContent = Math.floor(diff / 86400000);
      h.textContent = String(Math.floor(diff / 3600000) % 24).padStart(2, '0');
      m.textContent = String(Math.floor(diff / 60000) % 60).padStart(2, '0');
      s.textContent = String(Math.floor(diff / 1000) % 60).padStart(2, '0');
    }

    tick();
    const timer = setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-countdown]').forEach(init);
  });
})();
